import React from "react";
import tw from "twin.macro";
import DashboardStatsGrid from "../components/charts/DashboardStatsGrid";
import TransactionChart from "../components/charts/TransactionChart";
import FundsTable from "../components/charts/FundsTable";
import BuyerProfilePieChart from "../components/charts/BuyerProfilePieChart";
import PopularProducts from "../components/charts/PopularProducts";
import TickerTape from "components/charts/TickerTape";
import MarketMoodIndex from "components/charts/MarketMoodIndex";
import TradingViewComponent from "components/charts/TradingViewComponent";
import TradingViewComponent2 from "components/charts/TradingViewComponent2";
import OrdersTable from "components/charts/OrdersTable";
import Orders from "components/charts/Orders";

const Container = tw.div`flex flex-col gap-4 `;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between items-center w-full md:gap-12 `;
const Column = tw.div`flex-1`;
const Subheading = tw.h2`font-bold text-lg text-primary-500 mt-4`;

export default function Dashboard() {
  return (
    <Container>
      {/* <TickerTape /> */}
      
      <TwoColumn>
        <Column>
          <TradingViewComponent />
        </Column>
        <Column>
          <MarketMoodIndex />
        </Column>
      </TwoColumn>

      <DashboardStatsGrid />

      {/* Adjusted layout for smaller screens */}
      <div className="md:grid md:grid-cols-3 md:gap-4">
        <div className="md:col-span-2">
          <Subheading>Recent Orders</Subheading>
          <FundsTable />
        </div>
        {/* <div>
          <Subheading>Transaction Chart</Subheading>
          <TransactionChart />
        </div>
        <div>
          <Subheading>Buyer Profile Pie Chart</Subheading>
          <BuyerProfilePieChart />
        </div>
        <div>
          <Subheading>Popular Products</Subheading>
          <PopularProducts />
        </div> */}
      </div>
    </Container>
  );
}
